module.exports = __webpack_public_path__ + "img/forbes-logo.796687e1.svg";